import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";
import NotFound from "@/views/error-pages/NotFound.vue";

Vue.use(VueRouter);

// 自动加载模块路由
function autoImport() {
  const files = require.context("./modules", false, /.js$/);
  const routes = files.keys().reduce((routes, file) => {
    routes.push(...files(file).default);
    return routes;
  }, []);
  return routes;
}
const importRoutes = autoImport();
const routes = [
  {
    path: "/",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/login/Login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/invitehome",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/invite/Index.vue"),
    meta: {
      title: "邀您入驻科普号",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/login/Login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/invite",
    name: "inviteType",
    component: () =>
      import(/* webpackChunkName: "invite" */ "@/views/invite/SelectType.vue"),
    meta: {
      title: "认证科普号-科普号邀请",
    },
  },
  {
    path: "/invitesuccess",
    name: "invitesuccess",
    component: () =>
      import(/* webpackChunkName: "invite" */ "@/views/invite/success.vue"),
    meta: {
      title: "科普号信息审核-科普号邀请",
    },
  },
  {
    path: "/isKph",
    name: "isKph",
    component: () =>
      import(/* webpackChunkName: "invite" */ "@/views/invite/isKph.vue"),
    meta: {
      title: "科普号信息审核-科普号邀请",
    },
  },
  {
    path: "/kepuhao/personal",
    name: "personal",
    component: () =>
      import(
        /* webpackChunkName: "kepuhao" */ "@/views/apply-kepuhao/Personal.vue"
      ),
    meta: {
      title: "个人-账号信息-科普号邀请",
      cache: true,
    },
  },
  {
    path: "/kepuhao/organization",
    name: "organization",
    component: () =>
      import(
        /* webpackChunkName: "kepuhao" */ "@/views/apply-kepuhao/organization.vue"
      ),
    meta: {
      title: "科普文化企业-账号信息-科普号邀请",
      cache: true,
    },
  },
  {
    path: "/kepuhao/scientists",
    name: "scientists",
    component: () =>
      import(
        /* webpackChunkName: "kepuhao" */ "@/views/apply-kepuhao/scientists.vue"
      ),
    meta: {
      title: "地方科协-账号信息-科普号邀请",
      cache: true,
    },
  },
  {
    path: "/kepuyuan/spreads",
    name: "spreads",
    component: () =>
      import(/* webpackChunkName: "kepuyuan" */ "@/views/kepuyuan/Spreads.vue"),
    meta: {
      title: "邀您成为科普员",
      cache: true,
    },
  },
  {
    path: "/recommendindex",
    name: "recommendindex",
    component: () =>
      import(
        /* webpackChunkName: "recommend" */ "@/views/recommend/RecommendIndex.vue"
      ),
    meta: {
      title: "上传推荐函",
      cache: true,
    },
  },
  ...importRoutes,
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: "404-页面找不到了",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve({ ...savedPosition, behavior: "smooth" });
        } else {
          resolve({ x: 0, y: 0, behavior: "smooth" });
        }
      }, 100);
    });
  },
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  //const separator = " — ";
  const title = to?.meta?.title?.trim() || "";
  document.title = title;
  // title &&
  //   (document.title = [
  //     title,
  //     document.title.split(separator).reverse()[0],
  //   ].join(separator));

  if (from.name !== to.name) {
    // 添加组件缓存，只要进来的路由cache为true或数组长度不为0就直接缓存
    if (
      (Array.isArray(to?.meta?.cache ?? false) &&
        (to?.meta?.cache?.length ?? 0 > 0)) ||
      (to?.meta?.cache ?? false === true)
    ) {
      // 只要meta.cache有值且不是假值就缓存起来
      Store.commit("ADD_COMPONENTS", to.name);
    }

    // 移除组件缓存，
    // 1、循环cache值为数组的路由，
    // 2、该路由在组件缓存中
    // 3、并且该路由的cache不包含to.name
    // 4、并且当前路由也不是to.name
    // 那就从组件缓存中移除
    for (const route of router.options.routes.filter((route) =>
      Array.isArray(route?.meta?.cache ?? false)
    )) {
      if (
        Store.state.cacheComponents.includes(route.name) &&
        !route.meta.cache.includes(to.name) &&
        to.name !== route.name
      ) {
        Store.commit("REMOVE_COMPONENTS", route.name);
      }
    }
  }

  next();
});

export default router;
